import { buildQueryParams } from './buildQueryParams';

export default { 
    buildQueryParams
}